import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  placeholder: {
    id: 'callout.placeholder',
    defaultMessage: 'Type the quote',
  },
});

export type CalloutData = {
  text?: string;
  variant?: 'sideBorder' | 'quote';
  citation?: string;
};

const CalloutView = ({ data }: { data: CalloutData }) => {
  const intl = useIntl();
  const variant = data.variant || 'sideBorder';
  const isPlaceholder = !data.text;

  return (
    <blockquote className={`block-callout callout--${variant}`}>
      <p className={isPlaceholder ? 'callout__placeholder' : ''}>
        {data.text || intl.formatMessage(messages.placeholder)}
      </p>
      {data.citation && (
        <footer>
          <cite className="callout__citation">{data.citation}</cite>
        </footer>
      )}
    </blockquote>
  );
};

export default CalloutView;
